
/* eslint-disable react/no-children-prop */
import React, { createElement } from 'react';
import getStyle from './style';
import { getConfiguration } from '../../config';
import { GutterWidthContext } from '../Row';
import ScreenClassResolver from '../../context/ScreenClassResolver';
import { Div } from '../../primitives';

const Col = ({
  children = null,
  xs = null,
  sm = null,
  md = null,
  lg = null,
  xl = null,
  xxl = null,
  width = null,
  offset = {},
  push = {},
  pull = {},
  style = {},
  debug = false,
  component = Div,
  ...otherProps
}) =>
<ScreenClassResolver>
    {(screenClass) =>
  <GutterWidthContext.Consumer>
        {(gutterWidth) => {
      const theStyle = getStyle({
        forceWidth: width,
        width: {
          xs,
          sm,
          md,
          lg,
          xl,
          xxl
        },
        offset,
        pull,
        push,
        debug,
        screenClass,
        gutterWidth,
        gridColumns: getConfiguration().gridColumns,
        moreStyle: style
      });
      return createElement(component, { style: theStyle, ...otherProps, children });
    }}
      </GutterWidthContext.Consumer>}

  </ScreenClassResolver>;



export default Col;